import React, { useState } from "react";
import { useReportContext } from "../../../_context/ReportContext";
import { ClientAreas } from "./Scoring/ClientAreas";
import { OffCanvasClientList } from "./Scoring/OffCanvasClientList";
import { ClientAreaBasedScoringView } from "./Scoring/ClientAreaBasedScoringView";
import { ClientType } from "../../../_models/Client.model";
import "../../Admin/AddUsers/AddUsers.css";
import "../Reports.css";

export const Scoring = () => {
  const { newReport, setViewedAreas } = useReportContext();
  const [selectedAreaIndex, setSelectedAreaInex] = useState<number>(0);

  const area_based_scoring_types = process.env.REACT_APP_AREA_BASED_SCORING_TYPES?.split(",");

  const shouldUseAreaBasedScoring =
    area_based_scoring_types?.includes(newReport.Client.Type.toString()) ||
    newReport.Client.Type === ClientType.NDIS ||
    newReport.Client.Type === ClientType.Domestic;

  return (
    <div className="reports-page-wrapper" style={{ maxWidth: shouldUseAreaBasedScoring ? 900 : 1000 }}>
      {shouldUseAreaBasedScoring ? (
        <ClientAreaBasedScoringView />
      ) : (
        <>
          {/* Detailed Scoring Header */}
          <div className="rp-client-header" style={{ background: "linear-gradient(135deg, #0f1c34 0%, #1e3a8a 100%)", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <h2 className="rp-client-title">Detailed Scoring</h2>
              <div className="rp-client-email" style={{ marginTop: 4 }}>
                Review and score all individual items
              </div>
            </div>

            <div style={{ background: "rgba(255,255,255,0.15)", padding: "12px 24px", borderRadius: "12px", textAlign: "center" }}>
              <p style={{ margin: 0, fontSize: "0.8rem", color: "rgba(255,255,255,0.8)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "1px" }}>Total Score</p>
              <p style={{ margin: 0, fontSize: "2rem", fontWeight: 800, lineHeight: 1, color: "#fcd34d" }}>{newReport.TotalScore}</p>
            </div>
          </div>

          <div className="rp-scoring-layout">
            {/* Left Sidebar (Areas Navigation) */}
            <div className="rp-scoring-sidebar">
              <div className="au-card" style={{ padding: "16px", position: "sticky", top: "24px" }}>
                <OffCanvasClientList
                  key={"offCanvasMenu"}
                  selectedAreaIndex={selectedAreaIndex}
                  setSelectedAreaInex={setSelectedAreaInex}
                />
              </div>
            </div>

            {/* Right Content (Scoring View) */}
            <div className="rp-scoring-content">
              <ClientAreas
                selectedAreaIndex={selectedAreaIndex}
                isLastArea={selectedAreaIndex === newReport.Areas.length - 1}
                onNextArea={() => {
                  if (selectedAreaIndex < newReport.Areas.length - 1) {
                    const nextIndex = selectedAreaIndex + 1;
                    setSelectedAreaInex(nextIndex);
                    // Mark next area as viewed
                    setViewedAreas(prev => new Set(prev).add(newReport.Areas[nextIndex].Name));
                  }
                }}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
